interface SpecialitiesStore {
  expertise?: Record<string, any>;
}
const ActionType = {
  UPDATE_AGENT: "UPDATE_AGENT",
  GET_SPECIALITIES_DATA: "GET_SPECIALITIES_DATA",
};

export { ActionType, SpecialitiesStore };
